import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { WorkflowSectionRefreshEvent } from 'src/app/models/events/workflow-section-refresh-event';

@Injectable({
    providedIn: 'root',
})
export class WorkflowSectionEventsService {
    /**
     * Emis lorsque la section doit être rechargée.
     */
    public needRefresh = new Subject<WorkflowSectionRefreshEvent>();
}
